// import React, { useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { Container, Row, Col } from 'react-bootstrap';
// import HeaderTwo from '../../components/HeaderTwo';
// import { BreadcrumbBox } from '../../components/common/Breadcrumb';
// import FooterTwo from '../../components/FooterTwo';
// import { Styles } from './styles/account.js';

// function Register() {
//     useEffect(() => {
//         const form = document.getElementById("form_registration");
//         const fname = document.getElementById("registration_fname");
//         const lname = document.getElementById("registration_lname");
//         const email = document.getElementById("registration_email");
//         const user = document.getElementById("registration_user");
//         const password = document.getElementById("registration_password");
//         const cpassword = document.getElementById("registration_cpassword");

//         form.addEventListener("submit", formSubmit);

//         function formSubmit(e) {
//             e.preventDefault();

//             const fnameValue = fname.value.trim();
//             const lnameValue = lname.value.trim();
//             const emailValue = email.value.trim();
//             const userValue = user.value.trim();
//             const passwordValue = password.value.trim();
//             const cpasswordValue = cpassword.value.trim();

//             if (fnameValue === "") {
//                 setError(fname, "First name can't be blank");
//             } else {
//                 setSuccess(fname);
//             }

//             if (lnameValue === "") {
//                 setError(lname, "Last name can't be blank");
//             } else {
//                 setSuccess(lname);
//             }

//             if (emailValue === "") {
//                 setError(email, "Email can't be blank");
//             } else if (!isEmail(emailValue)) {
//                 setError(email, "Not a valid email");
//             } else {
//                 setSuccess(email);
//             }

//             if (userValue === "") {
//                 setError(user, "User name can't be blank");
//             } else {
//                 setSuccess(user);
//             }

//             if (passwordValue === "") {
//                 setError(password, "Password can't be blank");
//             } else {
//                 setSuccess(password);
//             }

//             if (cpasswordValue === "" || passwordValue !== cpasswordValue) {
//                 setError(cpassword, "Password doesn't match");
//             } else {
//                 setSuccess(cpassword);
//             }
//         }

//         function setError(input, message) {
//             const formControl = input.parentElement;
//             const errorMsg = formControl.querySelector(".registration_input-msg");
//             formControl.className = "form-control text-left error";
//             errorMsg.innerText = message;
//         }

//         function setSuccess(input) {
//             const formControl = input.parentElement;
//             formControl.className = "form-control success";
//         }

//         function isEmail(email) {
//             return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
//         }
//     });

//     return (
//         <Styles>
//             {/* Main Wrapper */}
//             <div className="main-wrapper registration-page">

//                 {/* Header 2 */}
//                 <HeaderTwo />

//                 {/* Breadcroumb */}
//                 <BreadcrumbBox title="Registration" />

//                 {/* Registration Area */}
//                 <section className="registration-area">
//                     <Container>
//                         <Row>
//                             <Col md="12">
//                                 <div className="registration-box">
//                                     <div className="registration-title text-center">
//                                         <h3>Registration</h3>
//                                     </div>
//                                     <form id="form_registration" className="form">
//                                         <p className="form-control">
//                                             <label htmlFor="registration_fname">First Name</label>
//                                             <input type="text" placeholder="First name" id="registration_fname" />
//                                             <span className="registration_input-msg"></span>
//                                         </p>
//                                         <p className="form-control">
//                                             <label htmlFor="registration_lname">Last Name</label>
//                                             <input type="text" placeholder="Last name" id="registration_lname" />
//                                             <span className="registration_input-msg"></span>
//                                         </p>
//                                         <p className="form-control">
//                                             <label htmlFor="registration_email">Email Address</label>
//                                             <input type="email" placeholder="Email address" id="registration_email" />
//                                             <span className="registration_input-msg"></span>
//                                         </p>
//                                         <p className="form-control">
//                                             <label htmlFor="registration_user">User Name</label>
//                                             <input type="text" placeholder="Username" id="registration_user" />
//                                             <span className="registration_input-msg"></span>
//                                         </p>
//                                         <p className="form-control">
//                                             <label htmlFor="registration_password">Password</label>
//                                             <input type="password" placeholder="*******" id="registration_password" />
//                                             <span className="registration_input-msg"></span>
//                                         </p>
//                                         <p className="form-control">
//                                             <label htmlFor="registration_cpassword">Confirm Password</label>
//                                             <input type="password" placeholder="Confirm password" id="registration_cpassword" />
//                                             <span className="registration_input-msg"></span>
//                                         </p>
//                                         <button>Register Now</button>
//                                     </form>
//                                     <div className="have_account-btn text-center">
//                                         <p>Already have an account? <Link to="/login">Login Here</Link></p>
//                                     </div>
//                                 </div>
//                             </Col>
//                         </Row>
//                     </Container>
//                 </section>

//                 {/* Footer 2 */}
//                 <FooterTwo />

//             </div>
//         </Styles>
//     )
// }

// export default Register

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/account.js';

function Register() {
    useEffect(() => {
        const form = document.getElementById("form_registration");
        const fullName = document.getElementById("registration_fullname");
        const email = document.getElementById("registration_email");
        const phone = document.getElementById("registration_phone");
        const course = document.getElementById("registration_course");
        const dob = document.getElementById("registration_dob");
        const gender = document.getElementById("registration_gender");
        const qualification = document.getElementById("registration_qualification");
        const address = document.getElementById("registration_address");

        if (!form) return;

        const formSubmit = (e) => {
            e.preventDefault();

            const fullNameValue = fullName.value.trim();
            const emailValue = email.value.trim();
            const phoneValue = phone.value.trim();
            const courseValue = course.value.trim();
            const dobValue = dob.value.trim();
            const genderValue = gender.value.trim();
            const qualificationValue = qualification.value.trim();
            const addressValue = address.value.trim();

            if (fullNameValue === "") {
                setError(fullName, "Full name can't be blank");
            } else {
                setSuccess(fullName);
            }

            if (emailValue === "") {
                setError(email, "Email can't be blank");
            } else if (!isEmail(emailValue)) {
                setError(email, "Enter a valid email address");
            } else {
                setSuccess(email);
            }

            if (phoneValue === "") {
                setError(phone, "Phone number can't be blank");
            } else if (!/^[0-9]{10}$/.test(phoneValue)) {
                setError(phone, "Enter a valid 10-digit phone number");
            } else {
                setSuccess(phone);
            }

            if (courseValue === "") {
                setError(course, "Please select a course");
            } else {
                setSuccess(course);
            }

            if (dobValue === "") {
                setError(dob, "Date of birth can't be blank");
            } else {
                setSuccess(dob);
            }

            if (genderValue === "") {
                setError(gender, "Please select gender");
            } else {
                setSuccess(gender);
            }

            if (qualificationValue === "") {
                setError(qualification, "Qualification can't be blank");
            } else {
                setSuccess(qualification);
            }

            if (addressValue === "") {
                setError(address, "Address can't be blank");
            } else {
                setSuccess(address);
            }
        };

        form.addEventListener("submit", formSubmit);

        function setError(input, message) {
            const formControl = input.parentElement;
            const errorMsg = formControl.querySelector(".registration_input-msg");
            formControl.className = "form-control text-left error";
            errorMsg.innerText = message;
        }

        function setSuccess(input) {
            const formControl = input.parentElement;
            formControl.className = "form-control text-left success";
            const errorMsg = formControl.querySelector(".registration_input-msg");
            if (errorMsg) errorMsg.innerText = "";
        }

        function isEmail(email) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
        }

        return () => {
            form.removeEventListener("submit", formSubmit);
        };
    }, []);

    return (
        <Styles>
            <div className="main-wrapper registration-page">

                <HeaderTwo />

                <BreadcrumbBox title="Admission Registration" />

                <section className="registration-area">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg="10">
                                <div className="registration-box">
                                    <div className="registration-title text-center">
                                        <h3>Student Admission Form</h3>
                                        <p className="border-bottom pb-2">
                                            Fill out the form below to begin your admission process at
                                            Care University of Education.
                                        </p>
                                    </div>

                                    <form id="form_registration" className="form mt-5">
                                        <Row>
                                            <Col md="6">
                                                <p className="form-control text-left">
                                                    <label htmlFor="registration_fullname">Full Name</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter your full name"
                                                        id="registration_fullname"
                                                    />
                                                    <span className="registration_input-msg"></span>
                                                </p>
                                            </Col>

                                            <Col md="6">
                                                <p className="form-control text-left">
                                                    <label htmlFor="registration_email">Email Address</label>
                                                    <input
                                                        type="email"
                                                        placeholder="Enter your email address"
                                                        id="registration_email"
                                                    />
                                                    <span className="registration_input-msg"></span>
                                                </p>
                                            </Col>

                                            <Col md="6">
                                                <p className="form-control text-left">
                                                    <label htmlFor="registration_phone">Phone Number</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter your phone number"
                                                        id="registration_phone"
                                                    />
                                                    <span className="registration_input-msg"></span>
                                                </p>
                                            </Col>

                                            <Col md="6">
                                                <p className="form-control text-left">
                                                    <label htmlFor="registration_course">Select Course</label>
                                                    <select id="registration_course">
                                                        <option value="">Select a course</option>
                                                        <option value="BCA">Bachelor of Computer Applications (BCA)</option>
                                                        <option value="BBA">Bachelor of Business Administration (BBA)</option>
                                                        <option value="Digital Marketing">Diploma in Digital Marketing & Online Advertising</option>
                                                        <option value="Python">Advanced Programming with Python</option>
                                                    </select>
                                                    <span className="registration_input-msg"></span>
                                                </p>
                                            </Col>

                                            <Col md="6">
                                                <p className="form-control text-left">
                                                    <label htmlFor="registration_dob">Date of Birth</label>
                                                    <input
                                                        type="date"
                                                        id="registration_dob"
                                                    />
                                                    <span className="registration_input-msg"></span>
                                                </p>
                                            </Col>

                                            <Col md="6">
                                                <p className="form-control text-left">
                                                    <label htmlFor="registration_gender">Gender</label>
                                                    <select id="registration_gender">
                                                        <option value="">Select gender</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                    <span className="registration_input-msg"></span>
                                                </p>
                                            </Col>

                                            <Col md="6">
                                                <p className="form-control text-left">
                                                    <label htmlFor="registration_qualification">Last Qualification</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter your last qualification"
                                                        id="registration_qualification"
                                                    />
                                                    <span className="registration_input-msg"></span>
                                                </p>
                                            </Col>

                                            <Col md="6">
                                                <p className="form-control text-left">
                                                    <label htmlFor="registration_city">City</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter your city"
                                                        id="registration_city"
                                                    />
                                                    <span className="registration_input-msg"></span>
                                                </p>
                                            </Col>

                                            <Col lg="12" md="12">
                                                <p className="form-control text-left">
                                                    <label htmlFor="registration_address">Address</label>
                                                    <textarea
                                                        placeholder="Enter your full address"
                                                        id="registration_address"
                                                        rows="4"
                                                    ></textarea>
                                                    {/* <span className="registration_input-msg"></span> */}
                                                </p>
                                            </Col>

                                            <Col lg="12" md="12">
                                                <p className="form-control text-left">
                                                    <label htmlFor="registration_message">Message / Remarks</label>
                                                    <textarea
                                                        placeholder="Write your message or admission enquiry"
                                                        id="registration_message"
                                                        rows="4"
                                                    ></textarea>
                                                    {/* <span className="registration_input-msg"></span> */}
                                                </p>
                                            </Col>
                                        </Row>

                                        <button type="submit">Submit Admission Form</button>
                                    </form>

                                    <div className="have_account-btn text-center">
                                        <p>
                                            Have a question? <Link to="/contact">Contact Us</Link>
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <FooterTwo />
            </div>
        </Styles>
    )
}

export default Register;